import { REPORT_PATH } from "../const";

export const REPORT_SUBMIT_PAGE = "submit";
export const REPORT_SUBMIT_PATH = `${REPORT_PATH}/${REPORT_SUBMIT_PAGE}`;
